module.exports = "/_next/static/images/mobile_logo-899c9344af7b88d3adbccaba89b14876.svg";